import React, { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import "../css/subjectAllocation.css";

import Loader from "common/components/Loader";

import { getSyllabusListSvc, allocateTeacherSvc } from "./subjectAllocationSvc";
import ManualAllocationSlider from "sms/tt/teacherAllocationManual/manualAllocationSlider";


const SubjectAllocationHeader = (props) => {
    const { setFilters, setLoader, setOpacity, syllabusId, setSyllabusId, saveSubjectSharedSlot, deleteSharedSlot, updateKey } = props;

    const scrollContainerRef = useRef(null);
    const [lstSyllabus, setLstSyllabus] = useState([]);
    const [selSyllabusId, setSelSyllabusId] = useState(0);
    const [lstClsSection, setLstClsSection] = useState([]);
    const [isTeacherAllocationVisible, setIsTeacherAllocationVisible] = useState(false);



    useEffect(() => {
        // console.log("SubjectAllocationHeader called");
        getSyllabusList();
    }, []);

    useEffect(() => {
        // console.log("SubjectAllocationHeader called");
        if (syllabusId !== selSyllabusId) {
            // console.log("changing syllabus from useEffect");
            handleSyllabusChange(syllabusId, lstSyllabus);
        }
    }, [syllabusId]);

    const getSyllabusList = () => {
        // console.log("getSyllabusList called");
        setLoader("block");
        setOpacity(0.5);
        getSyllabusListSvc(handleSyllabusListResponse);
    }

    const handleSyllabusListResponse = async (data) => {
        // console.log("handleSyllabusListResponse called, data", data);
        let obj = data;
        if (obj.status === 'Success') {
            await setLstSyllabus(obj.lstSyllabus);
            if (obj.lstSyllabus && obj.lstSyllabus.length) {
                await handleSyllabusChange(syllabusId ? syllabusId : obj.lstSyllabus[0].syllabusId, obj.lstSyllabus);
            }
        }
        else {
            if (obj.message == 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }
        setLoader("none");
        setOpacity(1);
    }

    const handleSyllabusChange = async (pSyllabusId, pLstSyllabus) => {
        // console.log("handlesyllabusChange called, pSyllabusId", pSyllabusId);
        await setSyllabusId(pSyllabusId);
        await setClassSectionList(pSyllabusId, pLstSyllabus);
        await setSelSyllabusId(pSyllabusId);
        // await setFilters({sub:null, sharedSlotNo: null, showOnlyBlockPeriods: false})
    }

    const allocateTeacher = () => {
        // console.log("Allocate Teacher Called");
        if (window.confirm("It will override all allocations including manual. Proceed?")) {
            setLoader("block");
            setOpacity(0.5);
            allocateTeacherSvc(handleAllocateTeacherResponse);
        } else {
            // console.log("User cancelled the allocation");
            return false;
        }
    }

    const viewReport = () => {
        // console.log("View Report called");
        const newPageUrl = "/allocationReports";
        window.open(newPageUrl, '_blank');
    }

    const handleAllocateTeacherResponse = async (data) => {
        // console.log("handleAllocateTeacherResponse called, data", data);
        let obj = data;
        if (obj.status === 'Success') {
            toast.success(obj.message);
            updateKey();
        }
        else {
            if (obj.message == 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }
        setLoader("none");
        setOpacity(1);
    }

    const setClassSectionList = (pSybId, pLstSyllabus) => {
        // console.log("setClassSectionList called, pSybId", pSybId);
        // console.log("pLstSyllabus", pLstSyllabus);
        if (pLstSyllabus && pLstSyllabus.length) {
            // const selectedSyllabus = pLstSyllabus.find(syllabus => syllabus.syllabusId === pSybId)
            let selectedSyllabus = [];
            for (let i = 0; i < pLstSyllabus.length; i++) {
                // console.log("pLstSyllabus[i]", pLstSyllabus[i]);
                if (pLstSyllabus[i].syllabusId == pSybId) {
                    // console.log("pLstSyllabus[i].syllabusId", pLstSyllabus[i].syllabusId);
                    // console.log("pLstSyllabus[i].lstSection", pLstSyllabus[i].lstSection);
                    selectedSyllabus = pLstSyllabus[i];
                    break;
                }
            }
            if (!!selectedSyllabus) {
                // console.log("selectedSyllabus", selectedSyllabus);
                setLstClsSection(selectedSyllabus.lstSection);
            } else {
                // console.log(`Syllabus with id ${pSybId} not found`);
                setLstClsSection([]);
            }
        } else {
            setLstClsSection([]);
        }
    }

    const allocateManually = () => {
        // console.log("allocateManually called");
        setIsTeacherAllocationVisible(true);
    }

    const closeSlider = () => {
        setIsTeacherAllocationVisible(false);
    }



    return (
        <div className="col-md-12 col-xs-12 col-centered padding-remove " >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                <div className="col-md-12 col-xs-12 col-centered padding-remove " style={{ display: "flex", flexDirection: "row", justifyContent: "end", gap: "10px", margin: "20px 0 0 0" }} >
                    <div style={{ width: "150px" }}>
                        <button type="button" style={{ width: "100%" }} className="btn btn-primary pull-right" onClick={(e) => { e.stopPropagation(); allocateTeacher(); }}>
                            Allocate Teacher
                        </button>
                    </div>
                    <div style={{ width: "150px" }}>
                        <button type="button" style={{ width: "100%" }} className="btn btn-primary pull-right" onClick={(e) => { e.stopPropagation(); allocateManually(); }}>
                            Allocate Manually
                        </button>
                    </div>
                    <div style={{ width: "120px" }}>
                        <button type="button" style={{ width: "100%" }} className="btn btn-primary pull-right" onClick={(e) => { e.stopPropagation(); viewReport(); }}>
                            View Report
                        </button>
                    </div>
                </div>
                {/* <div className="col-md-3 col-sm-3 col-xs-3 pull-right padding-remove">
                    <div className="col-md-6 col-sm-6 col-xs-6 padding-remove">
                        <button type="button" style={{ marginTop: 5 }} className="btn btn-primary pull-right" onClick={(e) => { e.stopPropagation(); allocateTeacher(); }}>
                            Allocate Teacher
                        </button>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-6 padding-remove">
                        <button type="button" style={{ marginTop: 5 }} className="btn btn-primary pull-right" onClick={(e) => { e.stopPropagation(); viewReport(); }}>
                            View Report
                        </button>
                    </div>
                </div> */}
            </div>
            <div className="col-md-12 col-xs-12 col-centered padding-remove " style={{ marginTop: "5px" }} >
                <div className="col-md-3 col-sm-3 col-xs-3 padding-remove">
                    <label
                        className="col-sm-3 text-left padding-remove"
                        style={{ top: "5px" }}
                    >
                        Syllabus
                    </label>
                    <div className="form-group col-sm-9 padding-remove">
                        <select autoComplete="off" name="Syllabus"
                            type="text" className="form-control "
                            value={selSyllabusId}
                            onChange={(e) => {
                                handleSyllabusChange(e.target.value, lstSyllabus); setFilters({
                                    sub: null,
                                    sharedSlotNo: null,
                                    showOnlyBlockPeriods: false
                                })
                            }}
                        >
                            <option value="0" >Syllabus</option>
                            {lstSyllabus && lstSyllabus.length > 0 ?
                                lstSyllabus.map((syllabus) => (
                                    <option
                                        key={syllabus.syllabusId}
                                        value={syllabus.syllabusId}
                                    >
                                        {syllabus.syllabus}
                                    </option>
                                )) : null
                            }
                        </select>
                    </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-6 ">
                    <div className="scroll-container" style={{ margin: "5px 0 0 0", border: "none" }}>
                        {lstClsSection && lstClsSection.length > 0 && (
                            <div style={{ display: "flex", flexDirection: "row", }}>
                                <div className="scroll-content" ref={scrollContainerRef}>
                                    {lstClsSection.map((clsSec) => (
                                        <div
                                            style={{ width: "150px", height: "30px", border: "1px solid #ccc", borderRadius: "25px", margin: "0 2px" }}
                                            className="col-sm-2 padding-remove"
                                            key={clsSec.sectionId}
                                        >
                                            <div style={{ padding: "3px 10px", justifyContent: "center", whiteSpace: "nowrap", overflow: "hidden" }}>
                                                {clsSec.cls + " - " + clsSec.section}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-md-3 col-sm-3 col-xs-3 text-right padding-remove" >
                    <div className="col-md-6 col-sm-6 col-xs-6 padding-remove" >
                        <button type="button" style={{ marginTop: 5 }} className="btn btn-primary pull-right" onClick={(e) => { e.stopPropagation(); saveSubjectSharedSlot(); }}>
                            Share Slots
                        </button>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-6 padding-remove" >
                        <button type="button" style={{ marginTop: 5 }} className="btn btn-primary pull-right" onClick={(e) => { e.stopPropagation(); deleteSharedSlot(); }}>
                            Delete Shared Slots
                        </button>
                    </div>
                </div>
            </div>
            {
                isTeacherAllocationVisible ?
                    <div className="slider1-60">
                        <ManualAllocationSlider
                            closeSlider={closeSlider}
                        />
                    </div>
                    : null
            }
        </div>
    );
}

export default SubjectAllocationHeader;